// extracted by mini-css-extract-plugin
export default {"logo":"LogoWithText_logo__iL4Fl"};